var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5024_165618)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5004 2.70667C8.81485 2.70667 9.70151 3.27444 10.2071 3.74889L12.1826 1.82C10.9693 0.692222 9.3904 0 7.5004 0C4.76263 0 2.39818 1.57111 1.24707 3.85778L3.5104 5.61556C4.07818 3.92778 5.64929 2.70667 7.5004 2.70667Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.22 7.15572C14.22 6.58016 14.1733 6.16016 14.0722 5.72461H7.5V8.32239H11.3578C11.28 8.96794 10.86 9.94016 9.92667 10.5935L12.1356 12.3046C13.4578 11.0835 14.22 9.28683 14.22 7.15572Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51778 8.38458C3.36484 7.93896 3.28601 7.47127 3.28444 7.00013C3.28444 6.51791 3.37 6.05124 3.51 5.61569L1.24667 3.85791C0.756464 4.83288 0.500782 5.90887 0.5 7.00013C0.5 8.12791 0.772222 9.19347 1.24667 10.1424L3.51778 8.38458Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50044 13.9998C9.39044 13.9998 10.9771 13.3776 12.136 12.3043L9.92711 10.5932C9.33599 11.0054 8.54266 11.2932 7.50044 11.2932C5.64933 11.2932 4.07822 10.0721 3.51822 8.38428L1.25488 10.1421C2.40599 12.4287 4.76266 13.9998 7.50044 13.9998Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5024_165618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.e0d21a921a6221da82eb14ac6680a3af.svg";
export { ForwardRef as ReactComponent };